import Subject from "../cse4sub/Subject";
import React from 'react'
//import csm from '../assets/CSE504mid21.pdf'
import cse from '../assets/CSE504end21.pdf'
import csm from '../assets/cse504mid21.pdf'
export default function Fl() {
  return (
    <div>
       <Subject title="Formal Language & Automata Theory(CSE504)"mid="Q. Paper"
    book1="An Introduction to Formal Languages and Automata, by Peter Linz, Fifth Edition, Jones & 
    Bartlett Learning." 
    book2=" "
    book1Link="https://fall14cs.files.wordpress.com/2017/04/an-introduction-to-formal-languages-and-automata-5th-edition-2011.pdf"
     book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}